import { apiFetcher, tokenFetcher } from "@/services/API.service";
import Swal from "sweetalert2";

import { ROUTE_LOGIN_OUT } from "@/constants/routes.constants";
import { routeInterceptorController } from "@/tests/RouteInterceptors/routeinterceptorController";
import { FetchResponse, JWT } from "@/types";

// We need to define the type of the data we expect to receive from the API
export type Tokens = {
  refreshTokenResponse: {
    refreshToken: string;
    authToken: string;
  };
};

export type MfaTokens = {
  mfaConfirmResponse: {
    refreshToken: string;
    authToken: string;
  };
};

// Give BE RefreshToken, get back JWT (R + Auth)
export async function fetchJwt(refreshToken: JWT): Promise<FetchResponse> {
  const response = await tokenFetcher({
    route: "/auth/refreshToken",
    method: "POST",
    options: { body: refreshToken },
  });

  if (response.status === 200) {
    // console.log("Refresh token successful");
    return response;
  } else {
    console.log("Refresh token failed");
    window.location.href = ROUTE_LOGIN_OUT;
    return response;
  }
}

// Give BE encoded Email, get back JWT (R + Auth)
export async function requestEmail(encodedEmail: string): Promise<number> {
  const route = "/auth/magicLink";
  console.log("HIT REQUEST EMAIL");

  if (import.meta.env.VITE_ENVIRONMENT === "testing") {
    console.log("Testing environment, using route interceptor");
    return routeInterceptorController(route);
  }
  const response = await tokenFetcher({
    route: route,
    method: "POST",
    options: { body: { encodedEmail: encodedEmail } },
  });

  console.log(response, "RESPONSE");
  if (response.status === 202) {
    // console.log("Email sent");
    return response.status;
  } else if (response.status === 400) {
    console.log("Contact admin");
    return response.status;
  } else if (response.status === 404) {
    console.log("Email not sent");
    return response.status;
  } else {
    console.log("Email not sent");
    return response.status;
  }
}

// Give BE encoded login details (Email, password), get back KeyUri (QR Scannable)
export async function enableMfa(
  encodedMFAEnableString: string
): Promise<FetchResponse> {
  console.log("HIT REQUEST ENABLE MFA");
  const response = await apiFetcher({
    route: "/auth/mfa/enable",
    method: "POST",
    options: { body: { encodedMFAEnableString } },
  });

  console.log(response);
  if (response.status === 200) {
    console.log("Request sent");
    return response;
  } else if (response.status === 409) {
    Swal.fire({
      icon: "error",
      title: "MFA already enabled",
      text: "Please contact support",
    });
    return response;
  } else {
    console.log("Request not sent");
    return response;
  }
}

// Give BE encoded Email, Pw, Code, get back JWT (R + Auth)
export async function mfaLogin(
  encodedMFAConfirmString: string
): Promise<FetchResponse> {
  console.log("HIT REQUEST CONFIRM MFA");
  console.log(encodedMFAConfirmString, "ENCODED STRING");

  const response = await tokenFetcher({
    route: "/auth/mfa/login",
    method: "POST",
    options: { body: { encodedMFAConfirmString } },
  });

  console.log(response, "RESPONSE");
  if (response.status === 200) {
    console.log("MFA CONFIRM sent");
    return response;
  } else {
    console.log("MFA CONFIRM Failed");
    return response;
  }
}

// Reset MFA: Give BE encoded login details (Email, password), get back KeyUri (QR Scannable)
export async function resetMFA(encodedString: string): Promise<string> {
  console.log("HIT REQUEST RESET MFA");
  // const response = await apiFetcher("/qrCodeReset", "POST", {
  //   body: { encodedString }
  // });

  const response = await apiFetcher({
    route: "/auth/mfa/reset",
    method: "POST",
    options: { body: { encodedString } },
  });

  console.log(response);
  console.log(encodedString);
  if (response.status === 202) {
    console.log("Request sent");
    console.log(response);
    return "success";
  } else if (response.status === 401) {
    return "invalid";
  } else {
    console.log("Request not sent");
    return "error";
  }
}
